export class PerspectivesService {
  static isPerspectiveObject(objId) {
    return objId.indexOf('persp') === 0;
  }

  static shouldRefreshPerspectivesList(objId) {
    return this.isPerspectiveObject(objId);
  }

  static shouldReopenCurrentPerspective(savedObjId, currentPerspectiveId) {
    return savedObjId === currentPerspectiveId;
  }
}
